import { render, staticRenderFns } from "./ModalDeleteCustomFont.vue?vue&type=template&id=489726bf&scoped=true"
import script from "./ModalDeleteCustomFont.vue?vue&type=script&lang=js"
export * from "./ModalDeleteCustomFont.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489726bf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('489726bf')) {
      api.createRecord('489726bf', component.options)
    } else {
      api.reload('489726bf', component.options)
    }
    module.hot.accept("./ModalDeleteCustomFont.vue?vue&type=template&id=489726bf&scoped=true", function () {
      api.rerender('489726bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/ModalDeleteCustomFont.vue"
export default component.exports